import type { IPermissionEnum } from '../interfaces'

export enum DataIndex {
  groupName = 'groupName',
  fileTotal = 'fileTotal',
  lcrTotal = 'lcrTotal',
  lcrVoided = 'lcrVoided',
  lcrNet = 'lcrNet',
  procTotal = 'procTotal',
  claimDol = 'claimDol',
  actions = 'actions',
  download = 'download',
  edit = 'edit',
  cal = 'cal',
  notes = 'notes',
  amount = 'amount',
  payee = 'payee',
  filenamesList = 'filenamesList',
  checkAmount = 'checkAmount',
  checkRunDay = 'chseckRunDay',
  eventDate = 'eventDate'
}
export enum DataIndexUser {
  L001 = 'L001',
  L002 = 'L002',
  L003 = 'L003',
  groups = 'groups',
  edit = 'edit',
  actions = 'actions'
}

export enum StatusIndex {
  success,
  error,
  warning,
  pending
}

// Need fix it, it's boring change too much enum
export enum Pages {
  Payments = 'Payments',
  Admin = 'Admin',
  CheckRegister = 'CheckRegister',
  Schedule = 'Schedule',
  Processing = 'Processing',
  Summary = 'Summary',
  Statistics = 'Statistics'
}

export enum PermissionMenu {
  User = 'view_user',
  CheckRegister = 'view_check_register',
  DashBoard = 'view_processing_dashboard',
  Schedule = 'view_group_schedule'
}

export const permissionObject = new Map<Pages, IPermissionEnum>()
permissionObject.set(Pages.CheckRegister, {
  name: Pages.CheckRegister,
  view: 'view_check_register',
  read: 'edit_check_register'
})
permissionObject.set(Pages.Payments, {
  name: Pages.Payments,
  view: 'view_check_register',
  read: 'edit_check_register'
})
// permissionObject.set(Pages.Statistics, {
//   name: Pages.Statistics,
//   view: 'view_check_register',
//   read: 'edit_check_register'
// })
permissionObject.set(Pages.Admin, { name: Pages.Admin, view: 'view_user', read: 'edit_user' })
permissionObject.set(Pages.Processing, {
  name: Pages.Processing,
  view: 'view_processing_dashboard',
  read: 'edit_processing_dashboard'
})
permissionObject.set(Pages.Summary, {
  name: Pages.Summary,
  view: 'view_processing_dashboard',
  read: 'edit_processing_dashboard'
})
permissionObject.set(Pages.Schedule, {
  name: Pages.Schedule,
  view: 'view_group_schedule',
  read: 'edit_group_schedule'
})

// TYPE EXPANDED ROW
export enum ExpandedType {
  none = 'none',
  // Just view one row
  mismatch = 'mismatch',
  // Open claim table
  singleProvider = 'singleProvider',
  // Open Zelis table
  singlePaymentType = 'singlePaymentType'
}

// Group
export enum DaysDiagram {
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  hold = 'hold'
}
